/**
 * assets/search-synonyms.js
 * Gedrag van snippets/search-synonyms.liquid
 *
 * Geknipt uit de inline <script> van dat bestand op 2026-08-15, 1:1.
 * Data komt uit dat bestand, gedrag staat hier. Zie ARCHITECTURE.md sectie 11.
 */

/* Synoniemen uit het JSON-eiland #ss-synoniemen hierboven, gevuld uit de
   metaobjecten search_synonym. Zie ARCHITECTURE.md sectie 11. */
var SS = { synoniemen: {} };
try {
  var _ssEl = document.getElementById('ss-synoniemen');
  if (_ssEl) SS = Object.assign(SS, JSON.parse(_ssEl.textContent) || {});
} catch (_e) {}

window.vcSynonyms = window.vcSynonyms || {};

/* ═══ Synoniemenkaart ═══
   Structuur: { "zoekterm": ["synoniem1", "synoniem2", ...], ... }
   + reverse map: elke synoniem verwijst terug naar alle gerelateerde termen
*/
(function() {
  const raw = SS.synoniemen || {};

  /* Forward map: zoekterm → synoniemen */
  const forward = {};
  /* Reverse map: synoniem → zoektermen (bidirectioneel) */
  const reverse = {};

  Object.entries(raw).forEach(([term, syns]) => {
    const normalizedTerm = term.toLowerCase().trim();
    forward[normalizedTerm] = syns.map(s => s.toLowerCase().trim());

    /* Reverse: elke synoniem verwijst ook naar de zoekterm + andere synoniemen */
    syns.forEach(syn => {
      const normalizedSyn = syn.toLowerCase().trim();
      if (!reverse[normalizedSyn]) reverse[normalizedSyn] = new Set();
      reverse[normalizedSyn].add(normalizedTerm);
      /* Voeg ook de andere synoniemen toe als alternatieven */
      syns.forEach(otherSyn => {
        const normalizedOther = otherSyn.toLowerCase().trim();
        if (normalizedOther !== normalizedSyn) {
          reverse[normalizedSyn].add(normalizedOther);
        }
      });
    });
  });

  /* Converteer Sets naar Arrays */
  Object.keys(reverse).forEach(key => {
    reverse[key] = Array.from(reverse[key]);
  });

  window.vcSynonyms = { forward, reverse };

  /**
   * Zoek alle synoniemen voor een term (forward + reverse)
   * @param {string} query - De zoekterm
   * @returns {string[]} Array van gerelateerde termen
   */
  window.vcSynonyms.lookup = function(query) {
    const q = query.toLowerCase().trim();
    const results = new Set();

    /* Forward: directe synoniemen */
    if (forward[q]) {
      forward[q].forEach(s => results.add(s));
    }

    /* Reverse: termen die naar deze zoekterm verwijzen */
    if (reverse[q]) {
      reverse[q].forEach(s => results.add(s));
    }

    /* Partial match: zoek ook op gedeeltelijke overeenkomst */
    if (q.length >= 3) {
      Object.keys(forward).forEach(term => {
        if (term.includes(q) || q.includes(term)) {
          forward[term].forEach(s => results.add(s));
          results.add(term);
        }
      });
    }

    /* Verwijder de oorspronkelijke query uit resultaten */
    results.delete(q);
    return Array.from(results);
  };

  /**
   * Verrijk een zoekquery met synoniemen voor Shopify predictive search
   * @param {string} query - De originele zoekterm
   * @returns {string} Verrijkte query (OR-gebaseerd)
   */
  window.vcSynonyms.enrichQuery = function(query) {
    const syns = this.lookup(query);
    if (syns.length === 0) return query;
    /* Geef maximaal 3 synoniemen mee om de search niet te vervuilen */
    const topSyns = syns.slice(0, 3);
    return [query, ...topSyns].join(' OR ');
  };
})();
